import * as XLSX from "xlsx";
import { ProductRewardRate } from "../../models/rewards-model";

interface ProductOption {
  label: string;
  value: number;
}

export const exportProductRewardRatesToExcel = (
  rewardRates: ProductRewardRate[],
  products: ProductOption[]
): void => {
  const getProductName = (productId: number): string => {
    const product = products.find((p) => p.value === productId);
    return product ? product.label : `Product #${productId}`;
  };

  const formatDate = (dateString: string | null): string => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const exportData = rewardRates.map((rate) => ({
    ID: rate.id,
    Product: getProductName(rate.productId),
    "Product ID": rate.productId,
    Type: rate.type,
    "Reward Rate (pts/₹100)": rate.rewardRatePer100Rs,
    "Effective From": formatDate(rate.effectiveFromDate),
    "Effective To": formatDate(rate.effectiveToDate),
    "Created Date": formatDate(rate.createdDate),
    "Created By": rate.createdBy
    // "Modified Date": formatDate(rate.modifiedDate),
    // "Modified By": rate.modifiedBy || "-",
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Product Reward Rates");

  // Set column widths
  worksheet["!cols"] = [
    { wch: 8 },   // ID
    { wch: 30 },  // Product
    { wch: 12 },  // Product ID
    { wch: 12 },  // Type
    { wch: 20 },  // Reward Rate
    { wch: 15 },  // Effective From
    { wch: 15 },  // Effective To
    { wch: 15 },  // Created Date
    { wch: 12 },  // Created By
    { wch: 15 },  // Modified Date
    { wch: 12 },  // Modified By
  ];

  const timestamp = new Date().toISOString().split("T")[0];
  const filename = `Product_Reward_Rates_${timestamp}.xlsx`;

  XLSX.writeFile(workbook, filename);
};
